import JsBarcode from "jsbarcode";

export function isEan13(code) {
  if (!/^\d{13}$/.test(code || "")) return false;
  let s = 0;
  for (let i = 0; i < 12; i++) s += Number(code[i]) * (i % 2 ? 3 : 1);
  return (10 - (s % 10)) % 10 === Number(code[12]);
}

// Returns module bits + quiet zones (in modules) so the SVG can be drawn vector-crisp at any size.
export function encodeBarcode(code) {
  const format = isEan13(code) ? "EAN13" : "CODE128";
  try {
    const o = {};
    JsBarcode(o, code, { format, flat: true });
    const bits = o.encodings.map((e) => e.data).join("");
    return { format, bits, quiet: format === "EAN13" ? [11, 7] : [10, 10] };
  } catch {
    return null;
  }
}

export function barRuns(bits, offset) {
  const runs = [];
  let i = 0;
  while (i < bits.length) {
    if (bits[i] === "1") {
      let j = i;
      while (j < bits.length && bits[j] === "1") j++;
      runs.push([offset + i, j - i]);
      i = j;
    } else i++;
  }
  return runs;
}

export const humanText = (code, format) => (format === "EAN13" ? `${code[0]} ${code.slice(1, 7)} ${code.slice(7)}` : code);
